export default "__VITE_ASSET__jEsvQFwX__"